import { useEffect, useState } from "react";
import Modal from "./modal";
import Shift from "../shiftInfo";
import moment from "moment";
import CustomModal from "./CustomModal";
import { useSelector } from "react-redux";
import { jobOpportunitySelector } from "../selector";
import { shiftTypeObj } from "../../../helpers/data";

export default (props) => {
  //  Job Opportuniuty Selector
  const { appointmentData,authUsersList ,jobMultishiftOccurreneUpdateList,masterData} = useSelector(jobOpportunitySelector);
  const [showModal, setShowModal] = useState(false);
  const [groupList,setGroupList] = useState({})
  const [groupLocationList,setgroupLocationList] = useState({})
  const edit = (event) => {
    event.preventDefault();
    props.sumbitJobDetails(false).then((success) => {
      if (success) {
        setShowModal(!showModal);
      }
    });
  };
  // Save Function
  const save = (event) => {
    event.preventDefault();
    props.sumbitJobDetails(false).then((success) => {
      if (success) {
        setShowModal(!showModal);
      }
    });
  };
  // got form Appointment data details for Job opportunity selector using filter
  const appointmentDataFilter = (filterId) => {
    const data = appointmentData.filter((item) => item.id === filterId);
    if (data?.length > 0) {
      return data[0].name;
    } else {
      return "";
    }
  };
  function groupbyUserName(arrList){
    let objGrp = {};
    arrList.forEach(item => {
      // console.log({item});
      if(!objGrp[item["candidateUniqueId"]]){
        objGrp[item["candidateUniqueId"]] = [item]
      }else {
        objGrp[item["candidateUniqueId"]].push(item)
      }
      
    })
    // console.log(objGrp)
    // return objGrp;
    setGroupList(objGrp)
}
const getAuthUserName = (id) => {
  const user = authUsersList.filter(item => item.value.toLowerCase() === id.toLowerCase());
  if (user?.length > 0) {
      return user[0]?.label
  } else {
      return ''
  }
}
useEffect(() => {
  if(props?.encounterOccurrence){
    groupbyUserName(props?.encounterOccurrence)
  }
},[props?.encounterOccurrence])
// console.log(Object.keys(groupbyPatientName(props?.encounterOccurrence))?.map(item => getAuthUserName(item)));
// console.log({occur:props?.encounterOccurrence});
useEffect(() => {
  if(jobMultishiftOccurreneUpdateList?.length > 1){
    const copyOcccurenceList = [...jobMultishiftOccurreneUpdateList?.slice(1)]
    const sortDateList = copyOcccurenceList?.sort((a,b) => new Date(a?.Start) - new Date(b?.Start))
    setgroupLocationList(sortDateList)
  }
},[jobMultishiftOccurreneUpdateList])
// function groupbyLocation(arrList){
//   let objGrp = {};
//   arrList?.forEach((item,index) => {
//     // console.log({item});
//    if(index > 0){
//     if(!objGrp[item["locationId"]]){
//       objGrp[item["locationId"]] = [item]
//     }else {
//       objGrp[item["locationId"]].push(item)
//     }
//    }
    
//   })
//   console.log({objGrp})
//   // return objGrp;
//   setgroupLocationList(objGrp)
// }
const getLocationName = (locationId) => {
  const locationName = masterData?.allJobLocations?.filter(item => parseInt(item?.id) === parseInt(locationId));
  if (locationName?.length > 0) {
      return locationName[0]?.name
  } else {
      return ''
  }
}

const openEditModal = () => {
  setShowModal(true)
}
  return (
    <div className="col-md-12 col-xl-12">
      <div className="card">
        {showModal && (
          <CustomModal label={"Shifts"} showHide={edit} saveFunction={save}>
            <Shift errors={props.errors} />
          </CustomModal>
        )}
        <div className="col-lg-12 col-md-12">
          <div className="row">
            <div className="card-header">
              <b>
                  {
                    parseInt(props?.recursionFlag) === 1 && <h5 className="mb-0">Single Shift Info</h5>
                    || 
                    props?.recursionFlag === 3 && <h5 className="mb-0">Multi Shift Info</h5>
                    ||
                    props?.recursionFlag === 2 && <h5 className="mb-0">Encounter Shift Info</h5>
                  }
              </b>
              {props.editMode && (
                <span
                  className="edit-icon"
                  id="btnShowModel_Job_Type"
                  onClick={openEditModal}
                >
                  <i className="fe fe-edit" title="Edit Shift Info"></i>
                </span>
              )}
            </div>
          </div>
        </div>
        <div className="card-body row">
          {props?.jobSummeryJobsShifts?.shiftType === 3 ? (
            <div class="row row-cols-1">
              <div class="col-4">
                <div>
                  <div className="d-flex">
                    <p className="fw-semibold col-6">Shift Start Date :</p>
                    <label className="col-6">
                      {moment(props?.jobSummeryJobsShifts?.jobStartDate).format(
                        "MM/DD/YYYY"
                      )}
                    </label>
                  </div>
                </div>
                <div>
                  <div className="d-flex">
                    <p className="fw-semibold col-6">Shift Start Time :</p>
                    <label className="col-6">{props?.shiftStartTime}</label>
                  </div>
                </div>
              </div>
              <div class="col-4">
                <div>
                  <div className="d-flex">
                    <p className="fw-semibold col-6">Shift End Date :</p>
                    <label className="col-6">
                      {moment(props?.jobSummeryJobsShifts?.jobEndDate).format(
                        "MM/DD/YYYY"
                      )}
                    </label>
                  </div>
                </div>
                <div className="row">
                  <div className="d-flex">
                    <p className="fw-semibold col-6">Shift End Time :</p>
                    <label className="col-6">{props?.shiftEndTime}</label>
                  </div>
                </div>
              </div>
              <div class="col-4">
                <div className="row">
                  <div className="d-flex">
                    <p className="fw-semibold col-6">Current Shift Date :</p>
                    <label className="col-6">
                      {moment(props?.currentShiftDate).format("MM/DD/YYYY")}
                    </label>
                  </div>
                </div>
                <div className="row">
                  <div className="d-flex">
                    <p className="fw-semibold col-6">Hours :</p>
                    <label className="col-6">{props?.shiftHours}</label>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <>
              {parseInt(props?.recursionFlag) === 2 ? (
                <div className="col-lg-12 col-md-12">
                  {props?.encounterOccurrence.length > 0 &&
                  !props?.jobEncounterOccurreneList?.length ? (
                  <>
                    <div className="row">
                      <div className="col-10">
                        <label className="form-label">Shift Start Date</label>
                        <label htmlFor="City">
                          {moment(props?.encounterOccurrence[props?.encounterOccurrence?.length - 1]?.Start).format(
                            "MM/DD/YYYY"
                          )}
                        </label>
                        {/* <div>
                          <label className="form-label">
                            Encounter Occurrence:
                          </label>
                          <div className="d-flex border-bottom">
                            <div className="col-2">
                              <label className="form-label">Start Time</label>
                            </div>
                            <div className="col-2">
                              <label className="form-label">End Time</label>
                            </div>
                            <div className="col-2">
                              <label className="form-label">Patient Name</label>
                            </div>
                            <div className="col-3">
                              <label className="form-label">
                                Appointment Type
                              </label>
                            </div>
                          </div>
                          {props?.encounterOccurrence?.map((item, index) => (
                            <>
                              <div className="d-flex border-bottom pt-2">
                                <div className="col-2">
                                  <label>
                                    {moment(item.Start).format("h:mm a")}
                                  </label>
                                </div>
                                <div className="col-2">
                                  <label>
                                    {moment(item.End).format("h:mm a")}
                                  </label>
                                </div>
                                <div className=" col-2">
                                  <label>{item.PatientName}</label>
                                </div>
                                <div className=" col-3">
                                  <label>
                                    {appointmentDataFilter(
                                      item.AppointmentType
                                    )}
                                  </label>
                                </div>
                              </div>
                            </>
                          ))}
                        </div> */}
                      </div>
                    </div>
                    <div className="row">
                        <div className="col-10">
                        <table className="table table-responsive">
                        <>
                           { groupList && Object.keys(groupList)?.map(item => getAuthUserName(item))?.map((item,index) => (
                            <>
                            <thead>
                            <tr>
                              <th key={index} className="text-capitalize">{item}</th>
                            </tr>
                            <tr>
                              <th className="text-capitalize">Start Date</th>
                              <th className="text-capitalize">Start Time</th>
                              <th className="text-capitalize">End Time</th>
                              <th className="text-capitalize">Patient Name</th>
                              <th className="text-capitalize">Appointment Type</th>
                            </tr>
                            </thead>
                             <tbody >
                              {
                                groupList && Object.values(groupList)[index]?.map(item => {
                                  return (
                                 <>
                                <tr>
                                 <td className="bg-white">{item?.Start ? moment(item.Start).format("MM/DD/YYYY"):""}</td>
                                 <td className="bg-white">{item?.Start ? moment(item.Start).format("h:mm a"):""}</td>
                                 <td className="bg-white">{item?.End ? moment(item.End).format("h:mm a"):""}</td>
                                 <td className="bg-white">{item?.PatientName}</td>
                                 <td className="bg-white"> {appointmentDataFilter(
                                 item.AppointmentType
                               )}</td>
                               </tr>
                                 </>
                                  )
                                })
                              }
                             </tbody>
                            </>
                         ))}
                        </>
                        </table>
                        </div>
                    </div>
                  </>

                  ) : (
                    ""
                  )}

                  {/* Encounter Occurrence Details */}
                  {props?.jobEncounterOccurreneList?.length > 0 ? (
                    <div className="form-group">
                      <label className="col-6 form-label">
                        Encounter Occurrence:
                      </label>

                      <table className="table table-responsive">
                        <thead>
                          <tr className="border-bottom ">
                            <th className="text-capitalize">Date</th>
                            <th className="text-capitalize">Start Time</th>
                            <th className="text-capitalize">End Time</th>
                            <th className="text-capitalize">CheckedIn Date</th>
                            <th className="text-capitalize">CheckedOut Date</th>
                            <th className="text-capitalize">Patient Name</th>
                            <th className="text-capitalize">Appointment Type</th>
                          </tr>
                        </thead>
                        <tbody>
                          {
                            props?.jobEncounterOccurreneList?.map((item, index) => {
                              return (
                                <tr className="border-bottom mt-2 bg-white">
                                  <td>{item.encounterStartToDisplay}</td>
                                  <td>{item.encounterStartTime}</td>
                                  <td>{item.encounterEndTime}</td>
                                  <td><span style={{
                                  background: `${
                                    item?.checkInStatus === 2
                                      ? "#ffd300"
                                      : "#fff"
                                  }`,
                                }}>{item.checkedInDateToDisplay}</span></td>
                                  <td>{item.checkedOutDateToDisplay}</td>
                                  <td>{item.patientName}</td>
                                  <td>{item.appointmentTypeName}</td>
                                </tr>
                              )
                            })
                          }
                        </tbody>
                      </table>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              ) : (
                <>
                       <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: "repeat(4,minmax(0,1fr))",
                      rowGap: "0.5rem",
                      columnGap: "1.75rem",
                    }}
                  >
                    <div>
                      <label className="form-label">Shift Start Date</label>
                      <label htmlFor="Location Name">
                        {props?.jobDateToDisplay}
                      </label>
                    </div>
                    {+props?.recursionFlag === shiftTypeObj.singleShift &&  <div>
                    <label className="form-label">Shift End Date</label>
                        <label htmlFor="City">
                        {moment(props?.shift?.singleShiftEndDate).format("MM/DD/YYYY")}
                        </label>
                    </div>}
                   
                    {props?.recursionFlag?.toString() === "3" && (
                      <div>
                        <label className="form-label">Shift End Date</label>
                        <label htmlFor="City">
                          {moment(props?.shift?.endDate).format("MM/DD/YYYY")}
                        </label>
                      </div>
                    )}
                    <div>
                      <label className="form-label">Shift Start Time</label>
                      <label htmlFor="Location Name">
                        {props?.shiftStartTime}
                      </label>
                    </div>
                    <div>
                      <label className="form-label">Shift End Time</label>
                      <label htmlFor="Address">{props?.shiftEndTime}</label>
                    </div>
                    <div >
                      <label className="form-label">Hours</label>
                      <label htmlFor="City">{props?.shiftHours}</label>
                    </div>
                  </div>
                  {/* <div className="col-lg-4 col-md-4">
                    <label className="form-label">Shift Date</label>
                    <label htmlFor="Location Name">
                      {props?.jobDateToDisplay}
                    </label>
                  </div>
                  {props?.recursionFlag?.toString() === "3" && (
                    <div className="col-lg-8 col-md-8">
                      <label className="form-label">Shift End Date</label>
                      <label htmlFor="City">
                        {moment(props?.shift?.endDate).format("MM/DD/YYYY")}
                      </label>
                    </div>
                  )}
                  <div className="col-lg-4 col-md-4">
                    <label className="form-label">Shift Start Time</label>
                    <label htmlFor="Location Name">
                      {props?.shiftStartTime}
                    </label>
                  </div>
                  <div className="col-lg-4 col-md-4">
                    <label className="form-label">Shift End Time</label>
                    <label htmlFor="Address">{props?.shiftEndTime}</label>
                  </div>
                  <div className="col-lg-4 col-md-4">
                    <label className="form-label">Hours</label>
                    <label htmlFor="City">{props?.shiftHours}</label>
                  </div> */}
                </>
              )}
            </>
          )}
          {props?.recursionFlag?.toString() === "3" && (
            <div className="col-lg-8 col-md-8">
              <label className="form-label">MultiShift</label>
              <label htmlFor="City">{props?.rrurleStr}</label>
            </div>
          )}

          {!props.editMode &&
          (props?.deletedOccurence?.length ||
            props?.modifiedOccurreneList?.length) ? (
            <div class="row row-cols-1">
              <div class="col-md-5 col-sm-10">
                <>
                  {props?.deletedOccurence &&
                    props?.deletedOccurence?.length > 0 && (
                      <div className="form-group">
                        <label className="col-6 form-label">
                          Deleted Occurrence:
                        </label>
                        <ul>
                          {props?.deletedOccurence.map((item, index) => (
                            <li
                              className="col-6 text-decoration-line-through"
                              key={index}
                            >
                              {item}
                            </li>
                          ))}
                        </ul>
                      </div>
                    )}
                  {props?.modifiedOccurreneList &&
                    props?.modifiedOccurreneList?.length > 0 &&
                    props?.jobSummeryJobsShifts?.shiftType === 3 && (
                      <div className="form-group">
                        <label className=" col-6 form-label">
                          Modified Occurrence:
                        </label>
                        <div className="d-flex border-bottom ">
                          <div className="col-3">
                            <label className="form-label">Start Date</label>
                          </div>
                          <div className="col-3">
                            <label className="form-label">End Date</label>
                          </div>
                          <div className="col-3">
                            <label className="form-label">Start Time</label>
                          </div>
                          <div className="col-3">
                            <label className="form-label">End Time</label>
                          </div>
                        </div>
                        {props?.modifiedOccurreneList.map((item, index) => (
                          <>
                            <div className="d-flex border-bottom pt-2">
                              <div className="col-3 ">
                                <label htmlFor="City">
                                  {item.startDateToDisplay}
                                </label>
                              </div>
                              <div className="col-3 ">
                                <label htmlFor="City">
                                  {item.endDateToDisplay}
                                </label>
                              </div>
                              <div className="col-3 ">
                                <label htmlFor="City">{item.startTime}</label>
                              </div>
                              <div className=" col-3">
                                <label htmlFor="City">{item.endTime}</label>
                              </div>
                            </div>
                          </>
                        ))}
                      </div>
                    )}
                </>
              </div>
            </div>
          ) : (
            ""
          )}
          {/* {
            parseInt(props?.recursionFlag) === 3 && Object.keys(groupLocationList)?.length  ? 
            <div className="col-12">
            <div className="row border-bottom">
              <div className="d-flex ">
                <p className="col-3 fw-bold  d-flex align-items-center justify-content-center">Location Name</p>
                <p className="col-9 d-flex align-items-center justify-content-between">
                  <span className="col-3  fw-bold d-flex align-items-center justify-content-center">Shift Date</span>
                  <span className="col-3 fw-bold d-flex align-items-center justify-content-center">Start Time</span>
                  <span className="col-3  fw-bold d-flex align-items-center justify-content-center">End Time</span>
                </p>

              </div>
            </div>
            <div className="row">
              {
                Object.keys(groupLocationList)?.map((location,index) =>{
                  return <div className=" d-flex border-bottom">
                    <span className="col-3 h-full d-flex align-items-center justify-content-center"> {getLocationName(location)}</span>
                      <div className="col-9">
                        {
                           Object.values(groupLocationList)[index]?.map(sub => {
                            return <>
                            <p className="d-flex align-items-center justify-content-between m-0 py-2">
                              <span className="col-3 d-flex align-items-center justify-content-center  h-full">{sub.Start ? moment(sub.Start).format("MM/DD/YYYY"):""}</span>
                              <span className="col-3 d-flex align-items-center justify-content-center h-full">{sub.Start ? moment(sub.Start).format("h:mm a"):""}</span>
                              <span className="col-3 d-flex align-items-center justify-content-center h-full">{sub.End ? moment(sub.End).format("h:mm a"):""}</span>
                            </p>
                            </>
                           })
                        }
                      </div>
                    </div>
                })
              }
            </div>
          </div>
        
        :""
          }  */}

                  {groupLocationList.length > 0 && (
                    <div className="col-lg-8 col-md-8">
                      <div className="form-group">
                      <label className="form-label">
                        Multishift Multi-Location Details:
                      </label>
                      <table className="table table-responsive">
                        <thead>
                          <tr className="border-bottom ">
                            <th className="text-capitalize">Location Name</th>
                            <th className="text-capitalize">Shift Date</th> 
                            <th className="text-capitalize">Start Time</th> 
                            <th className="text-capitalize">End Time</th>
                          </tr>
                        </thead>
                        <tbody>
                          {
                           groupLocationList?.map((item, index) => {
                              return (
                                <tr key={index} className="border-bottom mt-2 bg-white">
                                  <td>{getLocationName(item?.locationId)}</td>
                                  <td>{item.Start ? moment(item.Start).format("MM/DD/YYYY"):""}</td>
                                  <td>{item.Start ? moment(item.Start).format("h:mm a"):""}</td>
                                  <td>{item.End ? moment(item.End).format("h:mm a"):""}</td>
                                </tr>
                              )
                            })
                          }
                        </tbody>
                      </table>
                    </div>
                    </div>
                  ) }
        </div>
      </div>
    </div>
  );
};
